var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.227,
    height: 29.201,
    viewBox: "0 0 30.227 29.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33661",
    "data-name": "Tracciato 33661",
    d: "M10.707,24.016l2.59,7.449H3.26V4.8H33.486V31.465H24.211l5.066-7.449-6.266-6.361L18.8,16.988l-4.1.666Z",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23526",
    "data-name": "Raggruppa 23526",
    transform: "translate(-3.26 -4.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_279",
    "data-name": "Gruppo di maschere 279",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23333",
    "data-name": "Raggruppa 23333",
    transform: "translate(-8980 18304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33463",
    "data-name": "Tracciato 33463",
    d: "M8986.666-18290.084v15.338h24.457v-15.338l-12.194,5.174Z",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33465",
    "data-name": "Tracciato 33465",
    d: "M9006.717-18292.508l4.268,2.455",
    transform: "translate(0.139 -0.031)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33467",
    "data-name": "Tracciato 33467",
    d: "M8990.688-18288.137v-7.877h16.277v8.506",
    transform: "translate(-0.111 -0.717)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23336",
    "data-name": "Raggruppa 23336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33473",
    "data-name": "Tracciato 33473",
    d: "M8990.3-18292.959l-3.89,2.875",
    transform: "translate(0.259)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23335",
    "data-name": "Raggruppa 23335",
    transform: "translate(-8980 18304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23334",
    "data-name": "Raggruppa 23334",
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_33660",
    "data-name": "Tracciato 33660",
    transform: "translate(8994 -18288)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 1.5 C 4.864489555358887 1.5 1.5 4.864489555358887 1.5 9 C 1.5 13.1355094909668 4.864489555358887 16.5 9 16.5 C 13.1355094909668 16.5 16.5 13.1355094909668 16.5 9 C 16.5 4.864489555358887 13.1355094909668 1.5 9 1.5 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23332",
    "data-name": "Raggruppa 23332",
    transform: "translate(8998.758 -18283.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33469",
    "data-name": "Tracciato 33469",
    d: "M8996.644-18281.021l4.49-4.453,4.46,4.207",
    transform: "translate(-8996.644 18285.475)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33470",
    "data-name": "Tracciato 33470",
    d: "M8999.129-18276.426v-8.791",
    transform: "translate(-8994.655 18285.68)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33471",
    "data-name": "Tracciato 33471",
    d: "M8993.046-18292.539h11.4",
    transform: "translate(0 -1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33472",
    "data-name": "Tracciato 33472",
    d: "M8993.046-18292.539h11.4",
    transform: "translate(0 1.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArchive);
export default __webpack_public_path__ + "static/media/send-archive.aa7b8d8b05ce4b583e874db2403a2094.svg";
export { ForwardRef as ReactComponent };